webpackJsonp([0],{

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1594),
  /* template */
  __webpack_require__(1658),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductTreePicker',
  props: {
    value: { type: Array, required: false },
    spaceIds: { type: Array, required: false },
    expanded: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      search: null,
      selected: [],
      expandAll: false
    };
  },
  mounted: function mounted() {
    if (this.expanded) {
      this.expandAll = true;
      this.$refs.producttree.updateAll(this.expandAll);
    }
  },

  watch: {
    selected: function selected() {
      var products = this.selected.filter(function (item) {
        return String(item).indexOf('-') === -1;
      });
      this.$emit('input', products);
    },
    expandAll: function expandAll() {
      this.$refs.producttree.updateAll(this.expandAll);
    }
  },
  methods: {
    filter: function filter(item, search, textKey) {
      var val = item[textKey];
      return search && val && val.toLowerCase().indexOf(search.toLowerCase()) > -1;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['spaces', 'getProducts', 'getPractitionerById']), {
    filteredSpaces: function filteredSpaces() {
      var _this = this;

      if (this.spaceIds && this.spaceIds.length > 0) {
        return this.spaces.filter(function (space) {
          return _this.spaceIds.indexOf(space.id) !== -1;
        });
      }
      return this.spaces;
    },
    items: function items() {
      var _this2 = this;

      return this.filteredSpaces.map(function (item) {
        var r = Math.random().toString();
        var members = [];
        if (item.members) {
          members = item.members;
        }
        return {
          id: item.id + '-' + r,
          name: item.title,
          children: members.map(function (practitionerId) {
            var practitioner = _this2.getPractitionerById(practitionerId);
            return {
              id: item.id + '-' + practitioner.id,
              name: practitioner.full_name,
              type: 'practitioner',
              active: practitioner.is_active,
              archived: practitioner.archived,
              children: _this2.getProducts(practitionerId, item.id).map(function (item) {
                return {
                  id: item.id,
                  name: item.title,
                  owner_name: item.owner_name,
                  locations: item.locations
                };
              })
            };
          })
        };
      });
    }
  })
});

/***/ }),

/***/ 1568:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1566),
  /* template */
  __webpack_require__(1570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1570:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "clearable": "",
      "prepend-icon": "search",
      "label": "Search"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.search = ''
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.expandAll = !_vm.expandAll
      }
    }
  }, [_c('v-icon', [_vm._v("library_add")])], 1)], 1), _vm._v(" "), _c('v-treeview', {
    ref: "producttree",
    attrs: {
      "selectable": "",
      "open-on-click": "",
      "multiple-active": "",
      "search": _vm.search,
      "filter": _vm.filter,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n      " + _vm._s(item.name) + "\n      "), (item.archived === true) ? _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "dark": "",
            "color": "warning"
          }
        }, [_vm._v("archived")]) : _vm._e(), _vm._v(" "), (item.active === false) ? _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "dark": "",
            "color": "warning"
          }
        }, [_vm._v("deactivated")]) : _vm._e()]
      }
    }, {
      key: "append",
      fn: function(ref) {
        var item = ref.item;

        return _vm._l((item.locations), function(location) {
          return _c('v-chip', {
            key: ((item.id) + "-" + (location.id)),
            staticClass: "v-chip--x-small",
            attrs: {
              "outline": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("place")]), _vm._v("\n          " + _vm._s(location.name))], 1)
        })
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_client_ClientList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_RequestStatus__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignForm',
  components: { ClientList: __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList___default.a, RequestStatus: __WEBPACK_IMPORTED_MODULE_1__components_ui_RequestStatus___default.a },
  props: {
    value: { type: Object, required: true },
    formId: { required: true }
  },
  data: function data() {
    return {
      rel: {},
      request: {
        resource: 'ag.integrations',
        extra: 'jotform/assign_submission'
      }
    };
  },

  computed: {
    payload: function payload() {
      return {
        form_id: this.formId,
        submission_id: this.value.id,
        relationship_id: this.rel.id
      };
    }
  },
  methods: {
    save: function save() {
      this.request.data = this.payload;
      this.$request('save', this.request);
    },
    setRelationship: function setRelationship(rel) {
      this.rel = rel;
    }
  }
});

/***/ }),

/***/ 1587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_CopyTextField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_CopyTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_CopyTextField__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FormChecks',
  components: { HelpPopover: __WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover___default.a, CopyTextField: __WEBPACK_IMPORTED_MODULE_1__components_ui_CopyTextField___default.a },
  props: {
    properties: { type: Object, required: true },
    hasRelationshipId: { type: Boolean, required: true },
    webhookKey: { type: String, required: true }
  },
  methods: {
    isValidRedirectUrl: function isValidRedirectUrl(properties) {
      return properties.thankurl && properties.thankurl.indexOf('?relationship_id={relationship_id}') !== -1;
    }
  },
  computed: {
    webhookUrl: function webhookUrl() {
      return 'https://api.appointmentguru.co/api/v2/practitioner/integrations/jotform/incoming/?key=' + this.webhookKey;
    },
    hasWebHook: function hasWebHook() {
      var _this = this;

      var webhooks = this.getObjectPath(this.properties, 'integrations.webhooks.endpoints');
      if (webhooks) {
        var hooks = JSON.parse(webhooks);
        var agHooks = hooks.find(function (h) {
          return h === _this.webhookUrl;
        });
        if (agHooks) {
          return true;
        }
      }
      return false;
    }
  }
});

/***/ }),

/***/ 1588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FormListItem',
  components: { SpaceFaces: __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces_vue___default.a },
  props: {
    item: { type: Object, required: true },
    showDeleted: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  computed: {
    form: function form() {
      return this.item;
    },
    getSelectedClasses: function getSelectedClasses() {
      if (this.selectedForm && this.selectedForm.id) {
        if (this.form.id === this.selectedForm.id) {
          return ['blue', 'lighten-5'];
        }
      }
    },
    jotformIcon: function jotformIcon() {
      var url = 'https://ik.imagekit.io/appointmentguru/partners/jotform/jotform-icon-dark-800x800.png';
      return this.imageKitUrl(url, 'n-avatar_md');
    },
    statusclasses: function statusclasses() {
      if (this.form.status === 'DELETED') {
        return 'error';
      }
      if (this.form.status === 'ENABLED') {
        return 'success';
      }
    },
    withNotifications: function withNotifications() {
      return this.getObjectPath(this.form, 'linked_form.include_on_appointment_page', false);
    }
  }
});

/***/ }),

/***/ 1589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_ProductTreePicker_vue__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_ProductTreePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_ProductTreePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_ProductChips_vue__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_ProductChips_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_ProductChips_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FormSettings',
  components: { SpacePicker: __WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker_vue___default.a, ProductTreePicker: __WEBPACK_IMPORTED_MODULE_1__components_pickers_ProductTreePicker_vue___default.a, ProductChips: __WEBPACK_IMPORTED_MODULE_2__components_ui_ProductChips_vue___default.a },
  props: {
    formId: { required: true }
  },
  data: function data() {
    return {
      withClose: false,
      withLink: true,
      description: null,
      spaces: [],
      request: {
        resource: 'ag.spaces.forms',
        data: {}
      },
      showproductpicker: false
    };
  },

  watch: {
    formId: {
      immediate: true,
      handler: function handler() {
        if (this.formId) {
          this.get();
        }
      }
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200 && this.form) {
        this.withLink = this.form.include_on_appointment_page;
        this.description = this.form.description;
        this.spaces = this.form.spaces;
        if (this.withClose) {
          this.withClose = false;
          this.$emit('close');
        }
      }
    }
  },
  computed: {
    form: function form() {
      return this.getObjectPath(this.request, 'result', {});
    },
    products: function products() {
      return this.getObjectPath(this.form, 'products', []);
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    }
  },
  methods: {
    get: function get() {
      this.request.resourceId = this.formId;
      this.$request('get', this.request);
    },
    save: function save() {
      this.request.resourceId = this.formId;
      this.request.data = {
        include_on_appointment_page: this.withLink,
        description: this.description,
        spaces: this.spaces,
        products: this.products,
        order: this.form.order
      };

      if (this.form && this.form.order) {
        this.request.data['order'] = this.form.order;
      }
      this.$request('save', this.request);
    }
  }
});

/***/ }),

/***/ 1590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InstallJotForm',
  props: {
    integration: { type: Object, required: false }
  },
  data: function data() {
    return {
      eu: false,
      apikey: null,
      settings: {},
      confirmdelete: false,
      requests: {
        configure: {
          resource: 'ag.integrations',
          extra: 'jotform/configure',
          status: 0
        },
        delete: {
          resource: 'ag.integrations',
          extra: 'jotform/delete'
        }
      }
    };
  },

  computed: {
    getConfigStatus: function getConfigStatus() {
      return this.requests.configure.status;
    },
    deleteStatus: function deleteStatus() {
      return this.requests.delete.status;
    }
  },
  watch: {
    integration: {
      immediate: true,
      handler: function handler() {
        if (this.integration) {
          this.apikey = this.integration.token;
          if (this.integration.settings) {
            this.eu = this.integration.settings.eu;
          }
        }
      }
    },
    getConfigStatus: function getConfigStatus() {
      if (this.getConfigStatus === 200) {
        this.$emit('ok', this.requests.configure);
        this.apikey = this.getObjectPath(this.requests, 'configure.result.token');
        this.settings = this.getObjectPath(this.requests, 'configure.result.settings');
        if (this.settings) {
          this.eu = this.settings.eu;
        }
      }
    },
    deleteStatus: function deleteStatus() {
      if (this.deleteStatus === 204) {
        this.$emit('deleted', this.requests.delete);
      }
    }
  },
  methods: {
    configure: function configure() {
      var data = { token: this.apikey };
      if (this.eu === true) {
        data.eu = true;
      }
      this.requests.configure.data = data;
      this.$request('save', this.requests.configure);
    },
    uninstall: function uninstall() {
      if (this.integration && this.integration.id) {
        this.$request('delete', this.requests.delete);
      }
    }
  }
});

/***/ }),

/***/ 1591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomeRelationships',
  components: { SpacePicker: __WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker_vue___default.a },
  props: {
    form: { type: Object, required: true }
  },
  data: function data() {
    return {
      withLink: false,
      spaces: [],
      request: {
        resource: 'ag.integrations',
        extra: 'jotform/link'
      }
    };
  },

  methods: {
    link: function link(jotformId) {
      this.request.data = {
        jotform_id: jotformId,
        include_on_appointment_page: this.withLink,
        spaces: this.spaces.join(',')
      };
      this.$request('save', this.request);
    },
    emit: function emit(result) {
      this.$emit('success', result);
    }
  }
});

/***/ }),

/***/ 1592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_client_ClientList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_ShareCard_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_ShareCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cards_ShareCard_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShareForm',
  components: {
    ClientList: __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList_vue___default.a,

    ShareCard: __WEBPACK_IMPORTED_MODULE_1__components_cards_ShareCard_vue___default.a
  },
  props: {
    formId: { required: true }
  },
  data: function data() {
    return {
      rel: null
    };
  },

  methods: {
    setRelationship: function setRelationship(rel) {
      this.rel = rel;
    }
  },
  computed: {
    fname: function fname() {
      return this.getObjectPath(this.rel, 'client.first_name', 'the client');
    },
    label: function label() {
      return 'Share this link with ' + this.fname;
    },
    hint: function hint() {
      return 'Important: This is a custom link for ' + this.fname + '. Do not share this link with anyone else';
    },
    url: function url() {
      if (this.rel) {
        return 'https://form.jotform.com/' + this.formId + '?relationship_id=' + this.rel.id;
      }
      return null;
    },
    relId: function relId() {
      return this.getObjectPath(this.rel, 'id');
    },
    qr: function qr() {
      if (this.url) {
        var base = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=';
        return base + this.url;
      }
    }
  }
});

/***/ }),

/***/ 1593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormChecks_vue__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormChecks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormChecks_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ValidateForm',
  components: { FormChecks: __WEBPACK_IMPORTED_MODULE_1__FormChecks_vue___default.a },
  props: {
    formId: { required: true },
    webhookKey: { type: String, required: true }
  },
  data: function data() {
    return {
      agField: null,
      jfField: null,
      showRefreshNotice: false,
      requests: {
        validate: {
          resource: 'ag.integrations',
          extra: 'jotform/validate',
          method: 'post'
        },
        questions: {
          resource: 'ag.integrations',
          extra: 'jotform/questions',
          method: 'post'
        },
        savequestion: {
          resource: 'ag.integrations',
          extra: 'jotform/questions',
          method: 'post'
        }
      }
    };
  },

  watch: {
    formId: {
      immediate: true,
      handler: function handler() {
        this.refresh();
      }
    },
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 200) {
        this.validate();
        this.agField = null;
        this.jfField = null;
        this.showRefreshNotice = true;
      }
    }
  },
  computed: {
    mappedFields: function mappedFields() {
      return this.getObjectPath(this.requests.validate, 'result.mapped_fields', []);
    },
    unmappedFields: function unmappedFields() {
      return this.getObjectPath(this.requests.validate, 'result.unmapped_fields', []);
    },
    hasRelationshipId: function hasRelationshipId() {
      return this.unmappedFields.indexOf('relationship_id') === -1;
    },
    questions: function questions() {
      var qq = this.getObjectPath(this.requests.questions, 'result.content');
      if (qq) {
        qq = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(qq);
        return qq.sort(function (a, b) {
          if (parseInt(a.order) > parseInt(b.order)) {
            return 1;
          }
          if (parseInt(b.order) > parseInt(a.order)) {
            return -1;
          }
          return 0;
        });
      }
      return [];
    },
    properties: function properties() {
      return this.getObjectPath(this.requests.validate, 'result.properties', {});
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.requests.savequestion.status;
    },
    jotformIcon: function jotformIcon() {
      var url = 'https://ik.imagekit.io/appointmentguru/partners/jotform/jotform-icon-dark-800x800.png';
      return this.imageKitUrl(url, 'n-avatar');
    },
    agIcon: function agIcon() {
      var url = 'https://ik.imagekit.io/appointmentguru/brand/practitioner_icon_1024x1024.png';
      return this.imageKitUrl(url, 'n-avatar');
    }
  },
  methods: {
    refresh: function refresh() {
      this.validate();
      this.getQuestions();
    },
    validate: function validate() {
      this.requests.validate.params = { form_id: this.formId };
      this.$request('get', this.requests.validate);
    },
    getQuestions: function getQuestions() {
      this.requests.questions.params = { form_id: this.formId };
      this.$request('get', this.requests.questions);
    },
    unmap: function unmap(field) {
      this.requests.savequestion.params = { form_id: this.formId };
      this.requests.savequestion.data = {
        'qid': field.qid,
        'property': 'name',
        'value': field.id + '-' + field.qid
      };
      this.requests.savequestion.method = 'post';
      this.$request('save', this.requests.savequestion);
    },
    requireQuestion: function requireQuestion(field) {
      this.requests.savequestion.params = { form_id: this.formId };
      this.requests.savequestion.data = {
        'qid': field.qid,
        'property': 'required',
        'value': 'Yes'
      };
      this.requests.savequestion.method = 'post';
      this.$request('save', this.requests.savequestion);
    },
    saveQuestion: function saveQuestion() {
      this.requests.savequestion.params = { form_id: this.formId };
      this.requests.savequestion.data = {
        'qid': this.jfField,
        'property': 'name',
        'value': this.agField
      };
      this.requests.savequestion.method = 'post';
      this.$request('save', this.requests.savequestion);
    },
    isHiddenJotFormFieldType: function isHiddenJotFormFieldType(field) {
      var hiddenFields = ['control_text', 'control_button', 'control_image'];
      return hiddenFields.indexOf(field.type) !== -1;
    },
    isDisabledJotFormFieldType: function isDisabledJotFormFieldType(field) {
      var disabledTypes = ['control_head', 'control_divider', 'control_pagebreak'];
      if (disabledTypes.indexOf(field.type) === -1) {
        return false;
      }

      if (field.type === 'control_head') {
        return '##' + field.text;
      }
      if (field.type === 'control_divider') {
        return '----';
      }
      if (field.type === 'control_pagebreak') {
        return '----';
      }
      return field.text;
    }
  }
});

/***/ }),

/***/ 1594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listitems_SubmissionListItem__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listitems_SubmissionListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_listitems_SubmissionListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_SpaceFaces_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_SpaceFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_lists_SpaceFaces_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_Tombstone_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_Tombstone_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_Tombstone_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InstallJotForm_vue__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InstallJotForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InstallJotForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LinkJotForm_vue__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LinkJotForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LinkJotForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormListItem_vue__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FormListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AssignForm_vue__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AssignForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AssignForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ValidateForm_vue__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ValidateForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ValidateForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ShareForm_vue__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ShareForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ShareForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormSettings_vue__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__FormSettings_vue__);














var JOTFORM_BASE = 'https://jotform.com';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'JotFormIntegrationPage',
  components: {
    SubmissionListItem: __WEBPACK_IMPORTED_MODULE_0__components_listitems_SubmissionListItem___default.a,
    Tombstone: __WEBPACK_IMPORTED_MODULE_2__components_app_Tombstone_vue___default.a,
    SpaceFaces: __WEBPACK_IMPORTED_MODULE_1__components_lists_SpaceFaces_vue___default.a,
    HelpPopover: __WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover_vue___default.a,
    AssignForm: __WEBPACK_IMPORTED_MODULE_7__AssignForm_vue___default.a,
    ValidateForm: __WEBPACK_IMPORTED_MODULE_8__ValidateForm_vue___default.a,
    LinkJotForm: __WEBPACK_IMPORTED_MODULE_5__LinkJotForm_vue___default.a,
    FormListItem: __WEBPACK_IMPORTED_MODULE_6__FormListItem_vue___default.a,
    InstallJotForm: __WEBPACK_IMPORTED_MODULE_4__InstallJotForm_vue___default.a,
    ShareForm: __WEBPACK_IMPORTED_MODULE_9__ShareForm_vue___default.a,
    FormSettings: __WEBPACK_IMPORTED_MODULE_10__FormSettings_vue___default.a
  },
  data: function data() {
    return {
      apikey: '',
      eu: false,
      settings: {},
      selectedForm: {},
      validatedialog: false,
      sharedialog: false,
      linkdialog: false,
      assigndialog: false,
      showDeleted: false,
      showArchived: false,
      showUnlinked: true,
      formSettingsDialog: false,
      selectedSubmission: null,
      requests: {
        configure: {
          resource: 'ag.integrations',
          extra: 'jotform/configure',
          status: 0
        },
        integrations: {
          resource: 'ag.integrations',
          extra: 'jotform/integrations',
          status: 0
        },

        forms: {
          resource: 'ag.integrations',
          extra: 'jotform/forms',
          status: 0
        },
        submissions: {
          resource: 'ag.integrations',
          extra: 'jotform/submissions',
          status: 0
        }
      }
    };
  },
  mounted: function mounted() {
    this.getConfig();
    this.getIntegrations();
  },

  watch: {
    getConfigStatus: function getConfigStatus() {
      if (this.getConfigStatus === 200) {
        this.getForms();
        this.apikey = this.getObjectPath(this.requests, 'configure.result.token');
        this.settings = this.getObjectPath(this.requests, 'configure.result.settings');
        if (this.settings) {
          this.eu = this.settings.eu;
        }
      }
    },
    formsRequestStatus: function formsRequestStatus() {
      if (this.formsRequestStatus === 200 && this.selectedForm && this.selectedForm.id) {
        this.setSelectedFormById(this.selectedForm.id);
      }
    }
  },
  computed: {
    getConfigStatus: function getConfigStatus() {
      return this.requests.configure.status;
    },
    formsRequestStatus: function formsRequestStatus() {
      return this.requests.forms.status;
    },
    integration: function integration() {
      return this.requests.configure.result;
    },
    webhookKey: function webhookKey() {
      if (this.integration) {
        return this.integration.service_user_id;
      }
      return null;
    },
    integrations: function integrations() {
      var blank = { owned: [], other_forms: [] };
      return this.getObjectPath(this.requests, 'integrations.result', blank);
    },
    getFormsStatus: function getFormsStatus() {
      return this.requests.forms.status;
    },
    linkFormStatus: function linkFormStatus() {
      return this.requests.link.status;
    },
    forms: function forms() {
      return this.getObjectPath(this.requests, 'forms.result', []);
    },
    filteredForms: function filteredForms() {
      var forms = this.forms;
      if (this.showDeleted === false) {
        forms = forms.filter(function (form) {
          return form.status !== 'DELETED';
        });
      }
      if (this.showArchived === false) {
        forms = forms.filter(function (form) {
          return form.status !== 'DISABLED';
        });
      }
      if (this.showUnlinked === false) {
        forms = forms.filter(function (form) {
          return 'linked_form' in form;
        });
      }
      return forms;
    },
    submissions: function submissions() {
      return this.getObjectPath(this.requests, 'submissions.result.content', []);
    },
    activeFormJotFormUrl: function activeFormJotFormUrl() {
      return JOTFORM_BASE + '/build/' + this.selectedForm.id;
    }
  },
  methods: {
    setSelectedForm: function setSelectedForm(form) {
      this.selectedForm = form;
      this.getSubmissions(form.id);
    },
    showLinkFormDialog: function showLinkFormDialog(form) {
      this.setSelectedForm(form);
      this.linkdialog = true;
    },
    setSelectedFormById: function setSelectedFormById(formId) {
      var form = this.forms.find(function (f) {
        if (f.id === formId) {
          return true;
        }
      });
      if (form) {
        this.setSelectedForm(form);
      }
    },
    closeValidate: function closeValidate(formId) {
      this.setSelectedFormById(formId);
      this.validatedialog = false;
    },
    formLinked: function formLinked() {
      this.getForms();
      this.linkdialog = false;
      this.getSubmissions(this.selectedForm.id);
      this.validatedialog = true;
    },
    getIntegrations: function getIntegrations() {
      this.$request('get', this.requests.integrations);
    },
    getConfig: function getConfig() {
      this.$request('get', this.requests.configure);
    },
    getForms: function getForms() {
      this.$request('get', this.requests.forms);
    },
    getSubmissions: function getSubmissions(formId) {
      this.requests.submissions.params = { form_id: formId };
      this.$request('get', this.requests.submissions);
    }
  }
});

/***/ }),

/***/ 1603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductChips',
  props: {
    productIds: { type: Array, required: false },
    products: { type: Array, required: false },
    withSpaceName: { type: Boolean, default: false }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getProductById']), {
    items: function items() {
      var _this = this;

      if (this.products) {
        return this.products;
      }
      if (this.productIds) {
        return this.productIds.map(function (p) {
          return _this.getProductById(p);
        });
      }
      return [];
    }
  })
});

/***/ }),

/***/ 1631:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1586),
  /* template */
  __webpack_require__(1654),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1632:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1587),
  /* template */
  __webpack_require__(1666),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1633:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1588),
  /* template */
  __webpack_require__(1669),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1589),
  /* template */
  __webpack_require__(1660),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1590),
  /* template */
  __webpack_require__(1664),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1591),
  /* template */
  __webpack_require__(1670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1637:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1592),
  /* template */
  __webpack_require__(1653),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1593),
  /* template */
  __webpack_require__(1646),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1603),
  /* template */
  __webpack_require__(1644),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1644:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("before"), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-chip', {
      key: item.id,
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit('selected', item)
        }
      }
    }, [_vm._v("\n    " + _vm._s(item.title) + "\n    "), (_vm.withSpaceName) ? _c('span', [_vm._v("@" + _vm._s(item.space_name))]) : _vm._e()])
  }), _vm._v(" "), _vm._t("after")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1646:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.requests.validate
    }
  }), _vm._v(" "), (_vm.properties && _vm.properties.id) ? _c('v-card-title', {
    staticClass: "subtitle-1 grey lighten-4 py-1"
  }, [_vm._v("\n    Validating " + _vm._s(_vm.properties.title) + "\n    "), _c('v-btn', {
    attrs: {
      "href": ("https://www.jotform.com/build/" + _vm.formId),
      "target": "_blank",
      "flat": "",
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close', _vm.formId)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.formId) ? _c('v-card-text', [(_vm.properties && _vm.properties.id) ? _c('form-checks', {
    attrs: {
      "has-relationship-id": _vm.hasRelationshipId,
      "webhook-key": _vm.webhookKey,
      "properties": _vm.properties
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n        Select fields which you would like to link to values in AppointmentGuru\n      ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.showRefreshNotice,
      "type": "info",
      "dismissible": ""
    }
  }, [_c('strong', [_vm._v("Important")]), _vm._v(" If you have this form open in JotForm you must refresh the page for changes to reflect\n      ")]), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-3"
  }, [_c('v-card-text', {
    staticClass: "py-1"
  }, [_vm._v("\n          Map your form fields to your client's AppointmentGuru profile")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Field in AppointmentGuru")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Field in form")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  })], 1), _vm._v(" "), [_c('v-card', {
    staticClass: "mt-1"
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "pl-3 pt-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agField),
      expression: "agField"
    }],
    staticClass: "mr-2",
    staticStyle: {
      "border": "solid 1px #ccc",
      "padding": "2px",
      "margin-top": "0px",
      "width": "90%"
    },
    attrs: {
      "placeholder": "Choose a field in AppointmentGuru"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.agField = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Choose a field in AppointmentGuru")]), _vm._v(" "), _vm._l((_vm.unmappedFields), function(field) {
    return _c('option', {
      key: field,
      attrs: {
        "disabled": field.startsWith('-- ')
      },
      domProps: {
        "value": field
      }
    }, [_vm._v("\n                      " + _vm._s(field) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jfField),
      expression: "jfField"
    }],
    staticClass: "mr-2",
    staticStyle: {
      "border": "solid 1px #ccc",
      "padding": "2px",
      "margin-top": "7px",
      "width": "90%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jfField = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Choose a field from your form")]), _vm._v(" "), _vm._l((_vm.questions), function(question) {
    return [(!_vm.isHiddenJotFormFieldType(question)) ? [(_vm.isDisabledJotFormFieldType(question) !== false) ? _c('option', {
      key: question.qid,
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.isDisabledJotFormFieldType(question)) + "\n                          ")]) : _c('option', {
      key: question.qid,
      domProps: {
        "value": question.qid
      }
    }, [(question.type === 'control_radio') ? _c('span', [_vm._v("()")]) : _vm._e(), _vm._v(" "), (question.type === 'control_checkbox') ? _c('span', [_vm._v("[]")]) : _vm._e(), _vm._v("\n                          " + _vm._s(question.text) + "\n                          "), (question.required === 'Yes') ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), (question.hidden === 'Yes') ? _c('span', [_vm._v("(hidden)")]) : _vm._e()])] : _vm._e()]
  })], 2)]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "block": "",
      "outline": "",
      "loading": _vm.requests.savequestion.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveQuestion
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)]], 2)], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("These fields are mapped")]), _vm._v(" "), _vm._l((_vm.mappedFields), function(field) {
    return [_c('v-list-tile', {
      key: field.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticStyle: {
        "height": "30px",
        "line-height": "30px"
      }
    }, [_c('v-chip', {
      attrs: {
        "small": ""
      }
    }, [_c('v-avatar', [_c('img', {
      attrs: {
        "src": _vm.jotformIcon,
        "left": ""
      }
    })]), _vm._v(" "), (field.required === 'Yes') ? _c('span', {
      staticClass: "mr-1"
    }, [_vm._v("*")]) : _vm._e(), _vm._v("\n                " + _vm._s(field.text) + "\n              ")], 1), _vm._v(" "), _c('v-chip', {
      staticClass: "white",
      attrs: {
        "small": "",
        "flat": ""
      }
    }, [_c('v-icon', [_vm._v("arrow_right_alt")])], 1), _vm._v(" "), _c('v-chip', {
      attrs: {
        "small": ""
      }
    }, [_c('v-avatar', [_c('img', {
      attrs: {
        "src": _vm.agIcon,
        "left": ""
      }
    })]), _vm._v("\n                " + _vm._s(field.id) + "\n              ")], 1)], 1)], 1), _vm._v(" "), (field.required !== 'Yes') ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": "",
        "small": "",
        "disabled": _vm.requests.savequestion.loading
      },
      on: {
        "click": function($event) {
          return _vm.requireQuestion(field)
        }
      }
    }, [_vm._v("Make required")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": "",
        "small": "",
        "disabled": _vm.requests.savequestion.loading
      },
      on: {
        "click": function($event) {
          return _vm.unmap(field)
        }
      }
    }, [_vm._v("Unlink")])], 1)], 1)]
  })], 2) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$emit('close', _vm.formId)
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Revalidate form")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1653:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_vm._v("\n    Who would you like to share this form with?\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('client-list', {
    attrs: {
      "with-create": false,
      "show-list-initially": false
    },
    on: {
      "relationshipselected": _vm.setRelationship
    }
  }), _vm._v(" "), (_vm.relId && _vm.url) ? _c('share-card', {
    attrs: {
      "links": [_vm.url],
      "relationship-id": _vm.relId
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-footer', {
    staticClass: "caption"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n    To share a form with a client. From the client detail page:\n    client info -> forms -> share a form\n    ")], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1654:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle"
  }, [_vm._v("\n    Assign form\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.request
    }
  }), _vm._v(" "), _c('v-card-text', [_c('client-list', {
    attrs: {
      "show-list-initially": ""
    },
    on: {
      "relationshipselected": _vm.setRelationship
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Assign")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1658:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.integration && _vm.integration.id) ? _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.requests.forms.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.getForms
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n      Jotform\n      "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "dark": "",
      "color": "success"
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-1"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-0",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "two-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Jotforms")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.filteredForms), function(form) {
    return [_c('form-list-item', {
      key: form.id,
      attrs: {
        "item": form,
        "show-deleted": _vm.showDeleted
      },
      on: {
        "link": _vm.showLinkFormDialog,
        "selected": _vm.setSelectedForm
      }
    }), _vm._v(" "), (_vm.showDeleted || form.status !== "DELETED") ? _c('v-divider', {
      key: ("div-" + (form.id))
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "ml-3"
  }, [_c('v-checkbox', {
    staticClass: "ma-0 mt-2 pa-0",
    attrs: {
      "dense": "",
      "hide-messages": "",
      "small": "",
      "label": "Show deleted forms"
    },
    model: {
      value: (_vm.showDeleted),
      callback: function($$v) {
        _vm.showDeleted = $$v
      },
      expression: "showDeleted"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "dense": "",
      "hide-messages": "",
      "small": "",
      "label": "Show archived forms"
    },
    model: {
      value: (_vm.showArchived),
      callback: function($$v) {
        _vm.showArchived = $$v
      },
      expression: "showArchived"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "dense": "",
      "hide-messages": "",
      "small": "",
      "label": "Show unlinked forms"
    },
    model: {
      value: (_vm.showUnlinked),
      callback: function($$v) {
        _vm.showUnlinked = $$v
      },
      expression: "showUnlinked"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [(_vm.selectedForm && _vm.selectedForm.id) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "ma-0",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selectedForm.title) + "\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "disabled": !_vm.selectedForm.linked_form
    },
    on: {
      "click": function($event) {
        _vm.formSettingsDialog = true
      }
    }
  }, [_vm._v("\n                Settings\n                "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedForm.linked_form,
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.validatedialog = true
      }
    }
  }, [_vm._v("\n                Connect\n                "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("sync_alt")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedForm.linked_form,
      "target": "_blank",
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.sharedialog = true
      }
    }
  }, [_vm._v("\n                Share\n                "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("share")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.activeFormJotFormUrl,
      "target": "_blank",
      "flat": "",
      "small": ""
    }
  }, [_vm._v("\n                Open in JotForm\n                "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": !_vm.selectedForm.linked_form,
      "type": "warning"
    }
  }, [_vm._v("\n              Note: This form has not been linked to AppointmentGuru.\n              Would you like to link it now?\n              "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.linkdialog = true
      }
    }
  }, [_vm._v("Link form")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.selectedForm && _vm.selectedForm.linked_form) ? _c('v-card-title', {
    staticClass: "caption py-1 info--text",
    on: {
      "click": function($event) {
        _vm.formSettingsDialog = true
      }
    }
  }, [(_vm.selectedForm.linked_form.include_on_appointment_page) ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")]), _vm._v(" linked in notifications\n                "), _c('help-popover', {
    staticClass: "ml-4",
    attrs: {
      "small": ""
    }
  }, [_c('ul', [_c('li', [_vm._v("If you are using the default notifications, this will add a link to a page with all your forms linked.")]), _vm._v(" "), _c('li', [_vm._v("It will add the necessary information to link form submissions to your clients in AppointmentGuru.")]), _vm._v(" "), _c('li', [_vm._v("If you have customized your notifications, this link might not be added")]), _vm._v(" "), _c('li', [_vm._v("Links to your forms will show on the client's appointment detail page")]), _vm._v(" "), _c('li', [_vm._v("Links will not be included if the client has already completed the form")])])])], 1) : _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "warning"
    }
  }, [_vm._v("fiber_manual_record")]), _vm._v(" not linked in notifications\n                "), _c('help-popover', {
    staticClass: "ml-4",
    attrs: {
      "small": ""
    }
  }, [_c('ul', [_c('li', [_vm._v("If you are using the default notifications, this will add a link to a page with all your forms linked.")]), _vm._v(" "), _c('li', [_vm._v("It will add the necessary information to link form submissions to your clients in AppointmentGuru.")]), _vm._v(" "), _c('li', [_vm._v("If you have customized your notifications, this link might not be added")]), _vm._v(" "), _c('li', [_vm._v("Links to your forms will show on the client's appointment detail page")]), _vm._v(" "), _c('li', [_vm._v("Links will not be included if the client has already completed the form")])])])], 1), _vm._v(" "), _c('v-spacer'), _vm._v("\n\n              Available in these spaces:\n              "), _c('space-faces', {
    attrs: {
      "space-ids": _vm.selectedForm.linked_form.spaces
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2 ml-4",
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n                Recent submissions\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.requests.submissions.loading
    },
    on: {
      "click": function($event) {
        return _vm.getSubmissions(_vm.selectedForm.id)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.requests.submissions.loading) ? _c('tombstone') : [(_vm.submissions && _vm.submissions.length === 0) ? _c('p', {
    staticClass: "caption pa-3"
  }, [_vm._v("No submissions found")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.submissions), function(submission) {
    return [_c('submission-list-item', {
      key: submission.id,
      attrs: {
        "item": submission
      },
      on: {
        "assign_client": function($event) {
          _vm.assigndialog = true;
          _vm.selectedSubmission = submission
        }
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (submission.id))
    })]
  })]], 2)], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.integrations && _vm.integrations.other_forms && _vm.integrations.other_forms.length > 0) ? _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', {
    staticClass: "overline py-1 grey lighten-4"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "info"
    }
  }, [_vm._v("info")]), _vm._v("\n      Some other forms have been linked by a colleague of yours\n    ")], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', [_vm._l((_vm.integrations.other_forms), function(form) {
    return [_c('form-list-item', {
      key: form.id,
      attrs: {
        "item": form,
        "readonly": ""
      }
    })]
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('install-jot-form', {
    attrs: {
      "integration": _vm.integration
    },
    on: {
      "ok": _vm.getConfig,
      "delete": _vm.getConfig
    }
  }), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.formSettingsDialog),
      callback: function($$v) {
        _vm.formSettingsDialog = $$v
      },
      expression: "formSettingsDialog"
    }
  }, [(_vm.selectedForm && _vm.selectedForm.linked_form) ? _c('form-settings', {
    attrs: {
      "form-id": _vm.selectedForm.linked_form.id
    },
    on: {
      "close": function($event) {
        _vm.formSettingsDialog = false
      },
      "success": _vm.getForms
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.assigndialog),
      callback: function($$v) {
        _vm.assigndialog = $$v
      },
      expression: "assigndialog"
    }
  }, [(_vm.selectedSubmission && _vm.selectedForm && _vm.selectedForm.linked_form) ? _c('assign-form', {
    attrs: {
      "form-id": _vm.selectedForm.linked_form.id
    },
    on: {
      "close": function($event) {
        _vm.assigndialog = false
      }
    },
    model: {
      value: (_vm.selectedSubmission),
      callback: function($$v) {
        _vm.selectedSubmission = $$v
      },
      expression: "selectedSubmission"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.linkdialog),
      callback: function($$v) {
        _vm.linkdialog = $$v
      },
      expression: "linkdialog"
    }
  }, [(_vm.selectedForm) ? _c('link-jot-form', {
    attrs: {
      "form": _vm.selectedForm
    },
    on: {
      "close": function($event) {
        _vm.linkdialog = false
      },
      "success": _vm.formLinked
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs,
      "fullscreen": ""
    },
    model: {
      value: (_vm.validatedialog),
      callback: function($$v) {
        _vm.validatedialog = $$v
      },
      expression: "validatedialog"
    }
  }, [(_vm.validatedialog && _vm.selectedForm && _vm.selectedForm.id) ? _c('validate-form', {
    attrs: {
      "form-id": _vm.selectedForm.id,
      "webhook-key": _vm.webhookKey
    },
    on: {
      "close": _vm.closeValidate
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "520"
    },
    model: {
      value: (_vm.sharedialog),
      callback: function($$v) {
        _vm.sharedialog = $$v
      },
      expression: "sharedialog"
    }
  }, [(_vm.sharedialog && _vm.selectedForm && _vm.selectedForm.id) ? _c('share-form', {
    attrs: {
      "form-id": _vm.selectedForm.id
    },
    on: {
      "close": function($event) {
        _vm.sharedialog = false
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1660:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.request,
      "message200": false
    },
    on: {
      "ok": function($event) {
        return _vm.$emit('success')
      }
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-0 grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    Form settings\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('space-picker', {
    attrs: {
      "multiple": "",
      "label": "Which spaces do you want to use this form in?",
      "with-select": false
    },
    model: {
      value: (_vm.spaces),
      callback: function($$v) {
        _vm.spaces = $$v
      },
      expression: "spaces"
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [(_vm.form && _vm.form.products) ? [(_vm.products.length === 0) ? [_c('span', {
    staticClass: "info--text caption"
  }, [_vm._v("Form is shared on all appointment types")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showproductpicker = true
      }
    }
  }, [_vm._v("edit")])] : [_c('product-chips', {
    staticClass: "my-3",
    attrs: {
      "with-space-name": "",
      "product-ids": _vm.form.products
    },
    on: {
      "selected": function($event) {
        _vm.showproductpicker = true
      }
    }
  }, [_c('template', {
    slot: "before"
  }, [_vm._v("Only shown for: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "slot": "after",
      "small": "",
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showproductpicker = true
      }
    },
    slot: "after"
  }, [_vm._v("edit")])], 2)], _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showproductpicker),
      callback: function($$v) {
        _vm.showproductpicker = $$v
      },
      expression: "showproductpicker"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline py-1 grey lighten-4"
  }, [_vm._v("\n            Choose appointment types\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save();
        _vm.showproductpicker = false
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showproductpicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-alert', {
    staticClass: "ma-0 pa-2 caption",
    attrs: {
      "type": "info",
      "tile": "",
      "outlined": "",
      "value": true
    }
  }, [_vm._v("\n            Select products below to only show this form for those specific products\n          ")]), _vm._v(" "), _c('product-tree-picker', {
    attrs: {
      "expanded": "",
      "space-ids": _vm.spaces
    },
    model: {
      value: (_vm.form.products),
      callback: function($$v) {
        _vm.$set(_vm.form, "products", $$v)
      },
      expression: "form.products"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showproductpicker = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save();
        _vm.showproductpicker = false
      }
    }
  }, [_vm._v("Save and close")])], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "persistent-hint": "",
      "label": "Link this form",
      "hint": "Include a link to this form in notifications, on the client appointment information page and in your appointment link page"
    },
    model: {
      value: (_vm.withLink),
      callback: function($$v) {
        _vm.withLink = $$v
      },
      expression: "withLink"
    }
  }), _vm._v(" "), _c('v-textarea', {
    staticClass: "mt-3",
    attrs: {
      "outline": "",
      "persistent-hint": "",
      "label": "Form description",
      "hint": "You can add a description to give the client some context on this form - e.g.: you only need to full in this form for a certain appointment type"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "display order",
      "hint": "The order in which this form will be displayed to the client"
    },
    model: {
      value: (_vm.form.order),
      callback: function($$v) {
        _vm.$set(_vm.form, "order", $$v)
      },
      expression: "form.order"
    }
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": function($event) {
        _vm.withClose = true;
        _vm.save()
      }
    }
  }, [_vm._v("Save and close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1664:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 py-1 overline"
  }, [_vm._v("\n    Connect to JotForm\n    "), _c('v-spacer'), _vm._v(" "), (_vm.integration && _vm.integration.id) ? _c('v-chip', [(_vm.requests.configure.loading) ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "color": "amber",
      "indeterminate": "",
      "size": "18",
      "width": "2"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-avatar', [_c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v("\n      Installed\n    ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "label": "Your JotForm API key",
      "hint": "Create a key in JotForm from account settings -> API"
    },
    model: {
      value: (_vm.apikey),
      callback: function($$v) {
        _vm.apikey = $$v
      },
      expression: "apikey"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://jotform.com/myaccount/api",
      "target": "_blank"
    }
  }, [_vm._v("\n          Open Jotform Settings\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.jotform.com/help/253-how-to-create-a-jotform-api-key/",
      "target": "_blank"
    }
  }, [_vm._v("\n          How to create your JotForm API Key\n        ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Important")]), _vm._v(" Make sure you grant \"full access\" to the key you create")])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "persistent-hint": "",
      "label": "EU Datacenter",
      "hint": "TIP: If you don't know what this is, leave it as false"
    },
    model: {
      value: (_vm.eu),
      callback: function($$v) {
        _vm.eu = $$v
      },
      expression: "eu"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-card-actions', [(_vm.integration && _vm.integration.id) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.confirmdelete = true
      }
    }
  }, [_vm._v("Uninstall Integration")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.configure.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.configure
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.confirmdelete),
      callback: function($$v) {
        _vm.confirmdelete = $$v
      },
      expression: "confirmdelete"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        Confirm delete this integration\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to remove this integration?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.uninstall
    }
  }, [_vm._v("Uninstall Integration")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1666:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Checks")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [(_vm.properties && _vm.properties.id) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('v-icon', {
    attrs: {
      "color": "error"
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Able to fetch form from JotFom")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [(_vm.hasWebHook) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('v-icon', {
    attrs: {
      "color": "error"
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("WebHook is installed")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("The webhook is how JotForm sends submissions to AppointmentGuru")])], 1), _vm._v(" "), (!_vm.hasWebHook) ? _c('v-list-tile-action', [_c('help-popover', {
    staticClass: "ml-4"
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The problem")]), _vm._v("\n        Without the webhook installed, JotForm will not send submissions to AppointmentGuru,\n        and AppointmentGuru will be unable to connect your form submissions to a client in AppointmentGuru."), _c('br'), _vm._v("\n        Normally AppointmentGuru will create the webhook for you automatically when you connect your form.\n        In this case, it appears that something has gone wrong\n\n        "), _c('copy-text-field', {
    attrs: {
      "label": "Your webhook URL",
      "text-to-copy": _vm.webhookUrl
    }
  }), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The solution - manually add your webhook")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Go to your form in jotform")]), _vm._v(" "), _c('li', [_vm._v("Click on settings -> integrations")]), _vm._v(" "), _c('li', [_vm._v("Search for the \"webhook\" integration")]), _vm._v(" "), _c('li', [_vm._v("Paste the URL above and click \"add new webhook\"")]), _vm._v(" "), _c('li', [_vm._v("Click complete integration")])]), _vm._v("\n\n        Return to AppointmentGuru and click the validate form button below\n\n        "), _c('p', [_vm._v("Not comfortable doing it yourself? Send an email to support@appointmentguru.co and we can help you")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [(_vm.hasRelationshipId) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('v-icon', {
    attrs: {
      "color": "error"
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.hasRelationshipId) ? _c('v-list-tile-title', [_vm._v("Form has relationship_id")]) : _c('v-list-tile-title', [_vm._v("Form is missing a relationship_id field")]), _vm._v(" "), (!_vm.hasRelationshipId) ? _c('v-list-tile-sub-title', {
    staticClass: "error--text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "error"
    }
  }, [_vm._v("warning")]), _vm._v("\n        Without this your data cannot be linked to a client's profile in AppointmentGuru\n      ")], 1) : _c('v-list-tile-sub-title', [_vm._v("This is how AppointmentGuru knows which client to connect the form submission to")])], 1), _vm._v(" "), (!_vm.hasRelationshipId) ? _c('v-list-tile-action', [_c('help-popover', {
    staticClass: "ml-4"
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The problem")]), _vm._v("\n        In order for this form submission to be able to be linked to the client,\n        you need a relationship_id on your form.\n\n        "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The solution")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Go to your form in jotform")]), _vm._v(" "), _c('li', [_vm._v("Drag a \"short text\" field onto the form and name it relationship_id")]), _vm._v(" "), _c('li', [_vm._v("Click on properties -> advanced: turn on \"hide field\"")]), _vm._v(" "), _c('li', [_vm._v("Click on properties -> advanced: expand \"field details\" for unique_name, write: relationship_id")]), _vm._v(" "), _c('li', [_vm._v("Come back to this page and click on the \"revalidate\" button (bottom right) to check if you got it right")])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.properties && _vm.properties.activeRedirect === 'thankurl') ? [(_vm.properties && _vm.properties.isEUForm === '1') ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("autorenew")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Form redirects:\n          "), _c('a', {
    attrs: {
      "href": _vm.properties.thankurl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.properties.thankurl) + "\n            "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)]), _vm._v(" "), (!_vm.isValidRedirectUrl(_vm.properties)) ? _c('v-list-tile-sub-title', {
    staticClass: "error--text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "error"
    }
  }, [_vm._v("warning")]), _vm._v("\n          You are not passing relationship_id to the next form\n        ")], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isValidRedirectUrl(_vm.properties)) ? _c('v-list-tile-action', [_c('help-popover', {
    staticClass: "ml-4"
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The problem")]), _vm._v("\n          If you are redirecting this form to another JotForm, you need to pass the relationship_id to the new form\n          so that when the client submits that form it can be linked to their profile\n\n          "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The solution")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Go to your form in jotform")]), _vm._v(" "), _c('li', [_vm._v("Click on settings -> thank you page")]), _vm._v(" "), _c('li', [_vm._v("Where it says \"enter url\" you need to append "), _c('code', [_vm._v("?relationship_id={relationship_id}")]), _vm._v(" to the end of the URL")])]), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Your redirect url should look something like this:")]), _vm._v(" "), _c('copy-text-field', {
    attrs: {
      "text-to-copy": ((_vm.properties.thankurl) + "?relationship_id={relationship_id}")
    }
  }), _vm._v("\n\n          When you're done, come back here and click the revalidate form botton to check if you fixed it\n        ")], 1)], 1) : _vm._e()], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.properties && _vm.properties.isEUForm === '1') ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("euro")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Form is stored in the EU")])], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1669:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showDeleted || _vm.form.status !== "DELETED") ? _c('v-list-tile', {
    key: _vm.form.id,
    class: _vm.getSelectedClasses,
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.form)
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-img', {
    attrs: {
      "src": _vm.jotformIcon
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.form.title)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', [(_vm.form.status && _vm.form.status === 'DISABLED') ? _c('v-chip', {
    staticClass: "v-chip--x-small ml-0",
    class: _vm.statusclasses,
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.form.status) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.form.linked_form) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "dark": "",
      "color": "success"
    }
  }, [_vm._v("\n        Linked\n      ")]) : _vm._e(), _vm._v(" "), (_vm.withNotifications) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "color": "info"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("notifications_active")]), _vm._v(" Notifcation\n      ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.form.spaces) ? _c('v-list-tile-sub-title', [_vm._v("\n      Installed in: "), _c('space-faces', {
    attrs: {
      "space-ids": _vm.form.spaces
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.readonly) ? [(_vm.form.linked_form) ? [_c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_right")])], 1)], 1)] : _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "outline": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit("link", _vm.form)
      }
    }
  }, [_vm._v("\n        Link")])], 1)] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1670:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.request
    },
    on: {
      "ok": _vm.emit
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_vm._v("\n    Link a JotForm to AppointmentGuru\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "blue lighten-4 pa-2"
  }, [_c('v-subheader', {
    staticClass: "overline pa-0 ma-0"
  }, [_vm._v("Info:")]), _vm._v("\n      When you link a JotForm to AppointmentGuru, you will be able to share the form with\n      your AppointmentGuru clients and connect information from their form submissions\n      to their client profile\n    ")], 1), _vm._v(" "), _c('space-picker', {
    attrs: {
      "multiple": "",
      "label": "Which spaces do you want to use this form in?",
      "with-select": false
    },
    model: {
      value: (_vm.spaces),
      callback: function($$v) {
        _vm.spaces = $$v
      },
      expression: "spaces"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "persistent-hint": "",
      "label": "Link this form",
      "hint": "Include a link to this form in notifications, on the client appointment information page and in your appointment link page"
    },
    model: {
      value: (_vm.withLink),
      callback: function($$v) {
        _vm.withLink = $$v
      },
      expression: "withLink"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.request.loading
    },
    on: {
      "click": function($event) {
        return _vm.link(_vm.form.id)
      }
    }
  }, [_vm._v("Link form")])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.2b15d195dc409496d8a7.js